import Cookies from 'universal-cookie';
import { SavedSorting } from '../Types/SavedSorting';

export interface CustomerPreferences {
    pageSize?: number;
    sorter?: SavedSorting;
    selectedView?: number | 'default';
}

const COOKIE_NAME = 'customerPreferences';
const MAX_AGE = 31536000; // 1 year

export class CustomerPreferencesHelper {
    private static cookies = new Cookies();

    static getPreferences(): CustomerPreferences {
        return this.cookies.get(COOKIE_NAME) || {};
    }

    static setPreferences(preferences: Partial<CustomerPreferences>): void {
        const currentPrefs = this.getPreferences();
        this.cookies.set(
            COOKIE_NAME,
            { ...currentPrefs, ...preferences },
            { path: '/', maxAge: MAX_AGE }
        );
    }

    static getPageSize(): number | undefined {
        return this.getPreferences().pageSize;
    }

    static setPageSize(pageSize: number): void {
        this.setPreferences({ pageSize });
    }

    static getSorter(): SavedSorting | undefined {
        return this.getPreferences().sorter;
    }

    static setSorter(sorter: SavedSorting): void {
        this.setPreferences({ sorter });
    }

    static getSelectedView(): number | 'default' | undefined {
        return this.getPreferences().selectedView;
    }

    static setSelectedView(selectedView: number | 'default'): void {
        this.setPreferences({ selectedView });
    }

    static clearPreferences(): void {
        this.cookies.remove(COOKIE_NAME, { path: '/' });
    }
}
